import React, { useState } from 'react';
import { Shield, Key, Lock, Fingerprint } from 'lucide-react';
import { Button } from '../ui/button';
// Dummy data for 2FA setup
const DUMMY_QR_CODE = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=otpauth://totp/Flawtrack:user@example.com?secret=JBSWY3DPEHPK3PXP&issuer=Flawtrack';
import { Initial2FASetup } from './2FA/Initial2FASetup';
import { QRCodeSetup } from './2FA/QRCodeSetup';
import { VerificationSetup } from './2FA/VerificationSetup';



export const SecuritySettings = () => {
  const [setupStep, setSetupStep] = useState(0);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  return (
    <div className="space-y-6">
      <div className="bg-[#0F1629] rounded-xl border border-gray-800/50 p-6">
        <div className="flex items-center space-x-2 mb-6">
          <Shield className="h-5 w-5 text-blue-500" />
          <h2 className="text-lg font-semibold text-white">Security Settings</h2>
        </div>

        <div className="space-y-6">
          {/* Password */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Key className="h-4 w-4 text-gray-400" />
              <h3 className="text-sm font-medium text-white">Password</h3>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm text-gray-400">Current Password</label>
                <input
                  type="password"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter current password"
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm text-gray-400">New Password</label>
                <input
                  type="password"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter new password"
                />
              </div>
            </div>
          </div>

          {/* Two-Factor Authentication */}
          <div className="space-y-4 pt-6 border-t border-gray-800">
            <div className="flex items-center space-x-2">
              <Lock className="h-4 w-4 text-gray-400" />
              <h3 className="text-sm font-medium text-white">Two-Factor Authentication</h3>
            </div>
            
            {setupStep === 0 ? (
              <Initial2FASetup onEnableClick={() => setSetupStep(1)} />
            ) : setupStep === 1 ? (
              <QRCodeSetup
                qrCodeUrl={qrCodeUrl}
                error={error}
                onGenerateQRCode={async () => {
                  setQrCodeUrl(DUMMY_QR_CODE);
                  return Promise.resolve();
                }}
                onNext={() => setSetupStep(2)}
              />
            ) : (
              <VerificationSetup
                verificationCode={verificationCode}
                error={error}
                onVerificationCodeChange={setVerificationCode}
                onCancel={() => {
                  setSetupStep(0);
                  setQrCodeUrl('');
                  setVerificationCode('');
                  setError('');
                }}
                onVerify={async () => {
                  if (verificationCode === '123456') {
                    setSetupStep(0);
                    setQrCodeUrl('');
                    setVerificationCode('');
                  } else {
                    setError('Invalid verification code');
                  }
                  return Promise.resolve();
                }}
              />
            )}
          </div>

          {/* Security Log */}
          {/* <div className="space-y-4 pt-6 border-t border-gray-800">
            <div className="flex items-center space-x-2">
              <Fingerprint className="h-4 w-4 text-gray-400" />
              <h3 className="text-sm font-medium text-white">Security Log</h3>
            </div>
            
            <div className="space-y-3">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex items-center justify-between p-4 bg-gray-800/30 rounded-lg">
                  <div className="space-y-1">
                    <div className="text-sm font-medium text-white">Successful login</div>
                    <div className="text-sm text-gray-400">IP: 192.168.1.1 • Chrome on Windows</div>
                  </div>
                  <div className="text-xs text-gray-500">2 hours ago</div>
                </div>
              ))}
            </div>
          </div> */}
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 mt-8 pt-6 border-t border-gray-800">
          <Button variant="outline">Cancel</Button>
          <Button>Save Changes</Button>
        </div>
      </div>
    </div>
  );
};